import { render, staticRenderFns } from "./MonitorChart.vue?vue&type=template&id=addb587c&"
import script from "./MonitorChart.vue?vue&type=script&lang=js&"
export * from "./MonitorChart.vue?vue&type=script&lang=js&"
import style0 from "./MonitorChart.vue?vue&type=style&index=0&id=addb587c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports